import store from "../../../store";
import base_review from "./base_review.vue";

window.REVIEW =  new Vue({
    store,
    el: 'div#review_block',
    name : "REVIEW_BLOCK",
    data () {
        return {

        }
    },
    created () {

    },
    components : {
        base_review
    }
});
